import React from "react";
import styled from "styled-components/macro";

const StyledRoot = styled.div`
  display: flex;
  align-items: center;
  gap: 0.25rem;

  svg {
    width: var(--icon-size);
    height: var(--icon-size);
  }
`;

interface Props {
  className?: string;
  count?: number;
  fill?: string;
}

export const PeopleIcon: React.FC<Props> = ({ className, count, fill }) => {
  return (
    <StyledRoot className={className}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill={fill}>
        <path d="M16.5 13c-1.2 0-3.07.34-4.5 1-1.43-.67-3.3-1-4.5-1C5.33 13 1 14.08 1 16.25V19h22v-2.75c0-2.17-4.33-3.25-6.5-3.25zm-4 4.5h-10v-1.25c0-.54 2.56-1.75 5-1.75s5 1.21 5 1.75v1.25zm9 0H14v-1.25c0-.46-.2-.86-.52-1.22.88-.3 1.96-.53 3.02-.53 2.44 0 5 1.21 5 1.75v1.25zM7.5 12c1.93 0 3.5-1.57 3.5-3.5S9.43 5 7.5 5 4 6.57 4 8.5 5.57 12 7.5 12zm0-5.5c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm9 5.5c1.93 0 3.5-1.57 3.5-3.5S18.43 5 16.5 5 13 6.57 13 8.5s1.57 3.5 3.5 3.5zm0-5.5c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2z"></path>
      </svg>
      {count && <span>{count}</span>}
    </StyledRoot>
  );
};
